export enum IrisGridMode {
  Server = 'SERVER',
  Client = 'CLIENT',
}

